"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAddBasketOfferErrorResponse = exports.Name = exports.AddBasketOfferFailedEvent = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'add-basket-offer-failed';
const AddBasketOfferFailedEvent = exports.AddBasketOfferFailedEvent = Name;
const isAddBasketOfferErrorResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isAddBasketOfferErrorResponse = isAddBasketOfferErrorResponse;
